import React from "react";
import { connect } from "react-redux";

// Material UI components
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

// Actions
import { userActions } from "../../../store/actions/userActions";
import theme from "../../../themes/mdc-theme";

class Footer extends React.Component {
  componentDidMount = () => {
    this.props.getProductVersion();
  };

  checkForMaxWidth = () => {
    const route = location.pathname;
    if (
      [
        "/dashboard",
        "/dead-letter-queue",
        "/broadcast",
        "/register-popup",
        "/app-dashboard",
        "/plugin-details",
        "/tenant"
      ].includes(route)
    ) {
      return false;
    }
    return "xl";
  };

  render() {
    return (
      <Container maxWidth={this.checkForMaxWidth()}>
        <Grid container color={theme.palette.MDCColors.white} paddingTop="2rem">
          <p>Version {this.props.productVersion}</p>
        </Grid>
      </Container>
    );
  }
}

function mapState(state) {
  return {
    productVersion: state.authentication.productVersion,
  };
}

const actionCreators = {
  getProductVersion: userActions.getProductVersion,
};

export default connect(mapState, actionCreators)(Footer);
